module.exports = "<div class=\"footer\">\n  <a target=\"_blank\" href=\"http://workflowdigital.com\">Powered by Workflow Digital Ltd</a>\n</div>"